// extracted by mini-css-extract-plugin
module.exports = {"container":"page_container__eepwz","overlay":"page_overlay__1RYI6","inner":"page_inner__3vQSM","searchWrapper":"page_searchWrapper__1hpSp","loader":"page_loader__1EeZR"};